import React, { useEffect, useMemo, useState } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import Routes from '../constants/Routes';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { Query, useGetActiveWorkoutQuery } from 'src/graphql';

interface BottomTabsProps { }

const BOTTOM_TABS_ROUTES = Routes.filter((r) => r.showInBottomTabs !== undefined).sort((a, b) => a.showInBottomTabs! - b.showInBottomTabs!)

const BottomTabs: React.FC<BottomTabsProps> = ({ }) => {
    // const [showBottomTabs, setShowBottomTabs] = useState(true);
    // const [prevScrollY, setPrevScrollY] = useState(0);

    // const controlBottomTabs = () => {
    //     const currentScrollY = window.scrollY;

    //     if (currentScrollY > prevScrollY) {
    //         setShowBottomTabs(false)
    //     } else {
    //         setShowBottomTabs(true)
    //     }
    //     if (currentScrollY >= 0)
    //         setPrevScrollY(currentScrollY)
    // }


    // useEffect(() => {
    //     window.addEventListener('scroll', controlBottomTabs)
    //     return () => {
    //         window.removeEventListener('scroll', controlBottomTabs)
    //     }
    // }, [prevScrollY])


    const location = useLocation();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const { data: activeWorkoutData } = useGetActiveWorkoutQuery();

    return (
        <>
            <nav className={`fixed bg-slate-200 w-full bottom-0 font-Poppins h-[65px] md:hidden border-t border-light-secondary  z-[999] ease-in-out duration-500 translate-y-0}`}>
                <ul className='flex me-1 items-center h-full'>
                    {BOTTOM_TABS_ROUTES.map((r) => {

                        const Icon = r.icon;
                        const selected = matchPath(location.pathname, r.href);

                        const onClick = () => {
                            if (!selected)
                                navigate(r.href)
                        }

                        return (
                            <li key={r.label} className='flex w-full items-center flex-col gap-1 touch-auto select-none' onClick={onClick}>
                                <span><Icon className={`h-7 w-7  ease-in-out delay-100 ${selected ? 'text-red-500' : 'text-black'} pointer-events-none`} /></span>
                                <span className={`ease-in-out whitespace-nowrap delay-100 text-[0.7rem] text-[#6F767E] pointer-events-none ${selected && 'text-red-500'}`}>{r.label === 'Active' ? activeWorkoutData?.getActiveWorkout?.name : t(r.label)}</span>
                            </li>
                        )
                    })}

                </ul>
            </nav>
        </>
    )

}

export default BottomTabs;